"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartAdornment = void 0;
var react_1 = __importDefault(require("react"));
var InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment"));
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    startIcon: {
        color: theme.go.schemes.colors.system.IconMinor,
        position: 'absolute',
        left: 6,
    },
}); });
function StartAdornment(_a) {
    var className = _a.className, children = _a.children;
    var startIcon = useStyles().startIcon;
    return (react_1.default.createElement(InputAdornment_1.default, { className: (0, utils_1.cn)(className, startIcon), position: "start" }, children));
}
exports.StartAdornment = StartAdornment;
